// extracted by css-extract-rspack-plugin
export default {"otherVersions":"jInYb2D7PJkuad0D"};